(function () {

    'use strict';

    angular.module('app').controller('AccountsPayableController', AccountsPayableController);

    AccountsPayableController.$inject = [
        'Carrier',
        'AccountsPayableTableService'
    ];

    function AccountsPayableController(
        Carrier,
        AccountsPayableTableService
    ){

        const vm = this;

        Carrier.getCarriers(function (data) {
            vm.accountsPayableTable = new AccountsPayableTableService(data);
        }, function (err) {
            console.log(err);
        });
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/AccountsPayableController.js